import style from './Slide.module.scss';
import Button from '../../../../../../components/Button/Index';

const Slide = ({ className, title, descr, video, to }) => {
  return (
    <div className={`${style.slide} ${className}`}>
      <div className={style.slideInfo}>
        <div className={style.slideInfo__title}>{title}</div>
        <div
          className={style.slideInfo__descr}
          dangerouslySetInnerHTML={{ __html: descr }}
        ></div>
        <Button to={to} className={style.slideInfo__btn} title='Learn More' />
      </div>
      <div className={style.slideVideo}>
        <video
          className='lazy'
          playsInline
          webkit-playsInline
          loop
          autoPlay
          muted
          preload='none'
          src={video}
        ></video>
      </div>
    </div>
  );
};

export default Slide;
